import api from '../../../App/socket';

const USERS_STATUSES = {
    Active: '5bbb09fb60dc39407f5623aa',
    Suspended: '5bbb0a0160dc39407f5623ab',
};

export const getUsers = filters => api.send({
    api: 'db',
    model: 'User',
    action: 'Read',
    options: {
        attributes: 'all',
        limit: filters.limit,
        offset: filters.offset,
        include: [
            {
                model: 'user_group',
                attributes: ['name'],
            },
            {
                model: 'user_status',
                attributes: ['name'],
            },
            {
                model: 'department',
                attributes: ['name'],
            },
            {
                model: 'gender',
                attributes: ['name'],
            },
            {
                model: 'prefix_name',
                attributes: ['name'],
            },
        ],
        where: {
            $or: [
                {
                    'person.first_name': filters.searchText
                        ? {
                            $regex: filters.searchText,
                            $options: 'i',
                        }
                        : undefined,
                },
                {
                    'person.last_name': filters.searchText
                        ? {
                            $regex: filters.searchText,
                            $options: 'i',
                        }
                        : undefined,
                },
            ],
            ref_user_status: {
                $in: filters.showSuspendent ? Object.values(USERS_STATUSES) : [USERS_STATUSES.Active],
            },
        },
    },

}).then(response => response).catch(error => error);


export const countAllUsers = filters => api.send({
    api: 'db',
    model: 'User',
    action: 'Count',
    options: {
        attributes: 'all',
        include: [
            {
                model: 'user_group',
                attributes: ['name'],
            },
            {
                model: 'user_status',
                attributes: ['name'],
            },
            {
                model: 'department',
                attributes: ['name'],
            },
            {
                model: 'gender',
                attributes: ['name'],
            },
            {
                model: 'prefix_name',
                attributes: ['name'],
            },
        ],
        where: {
            $or: [
                {
                    'person.first_name': filters.searchText
                        ? {
                            $regex: filters.searchText,
                            $options: 'i',
                        }
                        : undefined,
                },
                {
                    'person.last_name': filters.searchText
                        ? {
                            $regex: filters.searchText,
                            $options: 'i',
                        }
                        : undefined,
                },
            ],
            ref_user_status: {
                $in: filters.showSuspendent ? Object.values(USERS_STATUSES) : [USERS_STATUSES.Active],
            },
        },
    },

}).then(response => response.options).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/requests/users_request.js